module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal message-modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    class: {
      'modal-content': true,
      'modal-error': _vm.message.type === 'error',
        'modal-warning': _vm.message.type === 'warn',
        'modal-success': _vm.message.type === 'success',
        'modal-clean': _vm.message.type === 'clean',
    }
  }, [_c('div', {
    staticClass: "modal-body text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.message.context)
    }
  }), _vm._v(" "), (_vm.message.confirm || _vm.message.showUnlock) ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.message.confirm) ? _c('div', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("確定")]) : _vm._e(), _vm._v(" "), (_vm.message.showUnlock) ? _c('div', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.openDevicesDiff
    }
  }, [_vm._v("重新解鎖")]) : _vm._e(), _vm._v(" "), (_vm.message.showLockDevice) ? _c('div', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.handleDevicesForLockup
    }
  }, [_vm._v("問題藥盒上鎖")]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dc71dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Message.vue
// module id = 1522
// module chunks = 1